var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    transform: "rotate(-180 21 21)",
    fill: "#49E400",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8954 16.5462C13.0679 16.3736 13.3041 16.2646 13.5766 16.2646C14.1034 16.2646 14.5393 16.7006 14.5393 17.2274L14.5393 27.2911L24.6031 27.2911C25.1299 27.2911 25.5658 27.7271 25.5658 28.2539C25.5658 28.7807 25.1299 29.2167 24.6031 29.2167L13.5766 29.2167C13.0498 29.2167 12.6138 28.7807 12.6138 28.2539L12.6138 17.2274C12.6138 16.9549 12.7228 16.7188 12.8954 16.5462Z",
    fill: "#262832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0489 27.4176L28.3353 12.1313C28.7077 11.7589 29.3253 11.7589 29.6977 12.1313C30.0701 12.5037 30.0701 13.1213 29.6977 13.4937L14.4114 28.7801C14.039 29.1524 13.4213 29.1524 13.0489 28.7801C12.6765 28.4077 12.6765 27.79 13.0489 27.4176Z",
    fill: "#262832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIcon);
export default __webpack_public_path__ + "static/media/deposit-icon.b1f628300f59f468e6005454977690d3.svg";
export { ForwardRef as ReactComponent };